import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, MenuItem, Typography } from '@mui/material'
import { motion } from 'framer-motion'
import { RouteImage } from '../../../../assets/routeImage'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'


// TIMELINE

// COMPONENT
import * as styled from '../../style/main.style'
import Header from '../../Header'
import Navbar from '../../Navbar'
import InputTextField from '../../../../component/input/inputTextField'
import { ButtonContained, ButtonOutlined } from '../../../../component/mui-custom/MuiCustom'
import ModalCustom from '../../../../component/modal/ModalCustom'
import HeaderTopicTable from '../../../../component/header-table/HeaderTopicTable'
import { colors } from '../../../../constants/colors'
import FilterSelect from '../../../../component/select/filterSelect'
import TableRowCommon from '../../../../component/table/TableRowCommon'
import TableCustom from '../../../../component/table/tableCustom'
import { setLoading, unsetLoading } from '../../../../store/slice/loading/loading.slice'
import EditDepartment from './detail/edit-department/EditDepartment'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

// API
import { DepartMentApi, departmentEditType } from '../../../../api/department/department.api';
import Loading from '../../../../component/loading/Loading'
import AddDepartment from './add-department/AddDepartment'
import { setDepartment } from '../../../../store/slice/departmentSlice/department.slice'
import NavigateListDepartment from './NavigateListDepartment'

const DepartmentList: React.FC = () => {
    const { idDepartmentProps } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const permission = useSelector((state: any) => state?.permission?.permission)

    const [isShowModal, setIsShowModal] = useState<boolean>(false);
    const [isShowModalAdd, setIsShowModalAdd] = useState<boolean>(false);
    const [isShowModalEditSubTable, setIsShowModalEditSubTable] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [departmentDetail, setDepartmentDetail] = useState<any>(null);
    const [departmentList, setDepartmentList] = useState<any[]>([]);
    const [idDepartment, setIdDepartment] = useState<number>(Number);

    const handleToggle = () => setIsShowModal(!isShowModal);
    const handleToggleAddModal = () => setIsShowModalAdd(!isShowModalAdd);
    const handleToggleEditSubModal = () => setIsShowModalEditSubTable(!isShowModalEditSubTable);

    const handleGetDetailDepartment = useCallback(async () => {
        dispatch(setLoading())
        await DepartMentApi.getDetailDepartment(Number(idDepartmentProps))
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setDepartmentDetail(res.data?.result);
                    setDepartmentList(res.data?.result?.departmentList);
                    setTotalItems(res.data?.result?.departmentList?.length);
                    if (res.data?.result?.departmentList?.length > 0) {
                        const departmentList = res.data?.result?.departmentList?.map((list: any) => {
                            return {
                                idDepartment: list?.idDepartment,
                                departmentStatus: list?.departmentStatus,
                                departmentName: list?.departmentName,
                                idDepartmentRef: list?.idDepartmentRef
                            }
                        })
                        dispatch(setDepartment(departmentList))
                    }
                }
            })
            .catch((error) => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [idDepartmentProps])

    const handleChangeStatusDepartment = async (idDepartment: number, status: string, obj: any) => {
        dispatch(setLoading())
        let conditionStatus: departmentEditType = {
            departmentAddress: obj?.departmentAddress,
            departmentEmail: obj?.departmentEmail,
            departmentFax: obj?.departmentFax,
            departmentName: obj?.departmentName,
            departmentStatus: status,
            departmentTel: obj?.departmentTel,
            idDepartmentRef: obj?.idDepartmentRef,
        }
        await DepartMentApi.editDepartments(idDepartment, conditionStatus)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                } else {
                    dispatch(unsetLoading())
                }
            })
            .catch(error => {
                console.log(error)
                dispatch(unsetLoading())
            })
            .finally(() => handleGetDetailDepartment())
    }

    useEffect(() => {
        handleGetDetailDepartment();
    }, [idDepartmentProps])

    const headCells = [
        {
            id: "RANK", width: 90, disablePadding: false, align: 'center', label:
                <HeaderTopicTable text='ลำดับ' minWidth='0px' align='center' />
        },
        {
            id: "AGENCY", disablePadding: true, align: 'center', label:
                <HeaderTopicTable align='start' minWidth='657px' text='หน่วยงาน' />
        },
        {
            id: "STATUS", disablePadding: true, align: 'center', label:
                <HeaderTopicTable align='center' text='สถานะ' />
        },
        {
            id: "EDIT", disablePadding: false, align: "left", label: ""
        }
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { idDepartment, departmentName, departmentStatus } =
            objData;

        const objRenderData = {
            key: idDepartment,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center", label: no,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "TEXT",
                    align: "left", label: departmentName,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "TEXT",
                    align: "center",
                    label:
                        <div>
                            <FilterSelect
                                disabled={permission?.find((list: any) => list?.code === "Agency.Edit")?.permit === false}
                                required
                                label={t('STATUS.LABEL')}
                                selectId="select-fiscal-year"
                                value={departmentStatus}
                                labelId="label-fiscal-year"
                                onchange={(e: React.ChangeEvent<HTMLSelectElement>) => handleChangeStatusDepartment(idDepartment, e.target.value, objData)}
                                options={[
                                    <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                        <li className='text-primary'>{t("STATUS.ACTIVE")}</li>
                                    </MenuItem>,
                                    <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                        <li className='text-danger'>{t("STATUS.INACTIVE")}</li>
                                    </MenuItem>
                                ]}
                            />
                        </div>,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    },
                    width: 10,
                    component:
                        <div className={`flex justify-center items-center  ${idDepartment === Number(idDepartmentProps) && 'pointer-events-none hidden'}`}>
                            <button
                                onClick={() => navigate(`/auth/setting/agency/detail/${idDepartment}`)}
                            >
                                <RemoveRedEyeOutlinedIcon
                                    className={`text-base_disable cursor-pointer`} />
                            </button>
                            {permission?.find((list: any) => list?.code === "Agency.Edit")?.permit === true && (
                                <Button onClick={() => {
                                    handleToggleEditSubModal()
                                    setIdDepartment(idDepartment)
                                }} className='cursor-pointer w-[24px]'>
                                    <img src={RouteImage.detailIcon} width={24} alt="icons" />
                                </Button>
                            )}
                        </div>

                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    useEffect(() => {
        const permissionCheck = permission?.find((list: any) => list?.code === "Agency.Read")?.permit;
        if (permissionCheck === false) {
            navigate('/404');
        }
    }, [navigate])


    console.log(idDepartmentProps, 'idDepartmentProps')
    console.log(idDepartment,'idDepartment')

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            {isShowModal &&
                <ModalCustom
                    enableExit={handleToggle}
                    alignHeader='center'
                    maxHeight='auto'
                    heading='ข้อมูลหน่วยงาน'
                    component={
                        <EditDepartment
                            idDepartment={Number(idDepartmentProps)}
                            fetchData={handleGetDetailDepartment}
                            toggleModal={handleToggle}
                        />
                    }
                />}

            {isShowModalEditSubTable &&
                <ModalCustom
                    enableExit={handleToggleEditSubModal}
                    alignHeader='center'
                    maxHeight='auto'
                    heading='แก้ไขข้อมูลหน่วยงาน'
                    component={
                        <EditDepartment
                            idDepartment={Number(idDepartment)}
                            fetchData={handleGetDetailDepartment}
                            toggleModal={handleToggleEditSubModal}
                        />
                    }
                />}

            {isShowModalAdd && (
                <ModalCustom
                    enableExit={handleToggleAddModal}
                    alignHeader='center'
                    maxHeight='auto'
                    heading='เพิ่มข้อมูลหน่วยงาน'
                    component={
                        <AddDepartment
                            idDepartmentRef={Number(idDepartmentProps)}
                            fetchData={handleGetDetailDepartment}
                            toggleModal={handleToggleAddModal}
                        />
                    }
                />
            )}
            <Navbar />
            <styled.MainContainer>
                <Header />
                {departmentDetail && (
                    <styled.Content>
                        <motion.section
                            initial={{ x: 100 }}
                            animate={{ x: 0 }}
                            transition={{ ease: "backInOut", stiffness: 100 }}
                            className='flex justify-start items-start md:justify-between flex-col md:flex-row md:items-center gap-3'
                        >
                            <article className='flex justify-center items-center'>
                                <Typography className='text-primary' variant='h4'>
                                    ข้อมูลหน่วยงาน
                                </Typography>
                                <NavigateListDepartment />
                            </article>
                            {permission?.find((list: any) => list?.code === "Agency.Edit")?.permit === true && (
                                <ButtonContained
                                    style={{
                                        display: permission?.find((list: any) => list?.code === "Agency.Edit")?.permit === false ? 'none' : ''
                                    }}
                                    onClick={handleToggle}
                                    sx={{
                                        maxWidth: "75px",
                                    }}>
                                    <Typography>{t("BUTTON.EDIT")}</Typography>
                                </ButtonContained>
                            )}
                        </motion.section>
                        <section className='mt-8 w-full'>
                            <InputTextField
                                disabled
                                disableColor='#EBEBE4'
                                heading='ชื่อหน่วยงาน'
                                value={departmentDetail?.departmentName}
                            />
                        </section>
                        <section className='mt-5 w-full'>
                            <InputTextField
                                disabled
                                disableColor='#EBEBE4'
                                heading='ที่ตั้ง'
                                value={departmentDetail?.departmentAddress}
                            />
                        </section>
                        <section className='mt-5 grid grid-cols-9 gap-4'>
                            <span className='col-span-9 md:col-span-3'>
                                <InputTextField
                                    disabled
                                    disableColor='#EBEBE4'
                                    heading='เบอร์โทรศัพท์'
                                    value={departmentDetail?.departmentTel}
                                />
                            </span>
                            <span className='col-span-9 md:col-span-3'>
                                <InputTextField
                                    disabled
                                    disableColor='#EBEBE4'
                                    heading='เบอร์โทรสาร'
                                    value={departmentDetail?.departmentFax}
                                /></span>
                            <span className='col-span-9 md:col-span-3'>
                                <InputTextField
                                    disabled
                                    disableColor='#EBEBE4'
                                    heading='E-Mail'
                                    type='email'
                                    value={departmentDetail?.departmentEmail}
                                />
                            </span>
                        </section>

                        <section className='mt-8 flex justify-start items-start md:justify-between flex-col md:flex-row md:items-center gap-3'
                        >
                            <Typography className='text-primary' variant='h4'>
                                หน่วยงานภายใต้
                            </Typography>
                            <ButtonOutlined
                                style={{
                                    display: permission?.find((list: any) => list?.code === "Agency.Create")?.permit === false ? 'none' : ''
                                }}
                                onClick={handleToggleAddModal}
                                sx={{ maxWidth: "75px" }}
                                startIcon={<img src={RouteImage.addButton} />} >
                                <Typography className='text-primary'>{t("BUTTON.ADD")}</Typography>
                            </ButtonOutlined>
                        </section>

                        <section className='mt-8 w-full h-auto'>
                            {departmentList && (
                                <TableCustom
                                    customScroll
                                    page={page}
                                    pageLimit={pageLimit}
                                    sortBy=""
                                    sortType="ASC"
                                    headCells={headCells}
                                    rowCount={totalItems || 0}
                                    rowsData={departmentList && departmentList.slice(
                                        (page - 1) * pageLimit,
                                        ((page - 1) * pageLimit) + pageLimit
                                    ).map((data: any, i: any) => {
                                        return renderData(data, i)
                                    })}
                                    onSort={() => { }}
                                    setPageLimit={(value: number) => setPageLimit(value)}
                                    setPage={(value: number) => setPage(value)}
                                />
                            )}
                        </section>
                    </styled.Content>
                )}
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default DepartmentList